import { action, axiosReq, uploadfileAWSS3, transcodeAWS, getTranscodeJobAWS } from './util';

export const VideoActionType = {
  ERROR: 'VIDEO_ERROR',
  UPLOADING: 'VIDEO_UPLOADING',
  UPLOAD_SUCCESS: 'VIDEO_UPLOAD_SUCCESS',
};

export function uploadVideo(climbId, file, successCallback) {
  return async dispatch => {
    dispatch(uploadingVideo(climbId));

    const axios = await axiosReq();
    // Prepare the video upload by retrieving various upload data
    // AWS Credentials
    // S3 Bucket, Region, TempFolder
    // Destination Filename
    // MediaConvert transcode Endpoint and Job Template Name
    axios.post('/api/prepare-video-upload')
      .then(async ({ data }) => {
        const { credentials, region, filename, tempFolder, transcodeJobTemplate, bucket, endpoint, role } = data;

        // Upload Base File to S3 Temp Folder
        const upload = await uploadfileAWSS3(
          credentials,
          region,
          bucket,
          tempFolder,
          filename,
          file,
          ({ loaded, total }) => {
            // Round to nearest tenth of a percent
            dispatch(uploadingVideo(climbId, false, ((loaded / total) * 100).toFixed(0)));
          }
        );

        // Transcode Base File into compressed mp4 (still in Temp Folder)
        const transcodeJob = await transcodeAWS(credentials, endpoint, role, transcodeJobTemplate, bucket, region, upload);
        // Poll Transcode Job Status
        updateVideoCompressStatus(climbId, dispatch, credentials, endpoint, region, transcodeJob.Job.Id, `https://s3-us-west-1.amazonaws.com/${bucket}/${upload}.mp4`, successCallback);
      })
      .catch(err => {
        console.log(err);
        dispatch(errorVideo(climbId, 'Video upload failed'));
      });
  };
}

export function uploadingVideo(climbId, isTranscoding = false, uploadPercent) {
  return action(VideoActionType.UPLOADING, { climbId, isTranscoding, uploadPercent });
}

export function uploadVideoSuccess(climbId, url, thumbUrl) {
  return action(VideoActionType.UPLOAD_SUCCESS, { climbId, url, thumbUrl });
}

export function errorVideo(climbId, error) {
  return action(VideoActionType.ERROR, { climbId, error });
}

async function updateVideoCompressStatus(climbId, dispatch, credentials, endpoint, region, jobId, destination, successCallback) {
  try {
    const jobUpdate = await getTranscodeJobAWS(credentials, endpoint, region, jobId);
    // Check Transcode Job Status -- If Complete dispatch Success; else continue polling
    if (jobUpdate.Job.Status !== 'COMPLETE') {
      dispatch(uploadingVideo(climbId, true));
      setTimeout(() => updateVideoCompressStatus(climbId, dispatch, credentials, endpoint, region, jobId, destination, successCallback), 3000);
    } else {
      dispatch(uploadVideoSuccess(climbId, destination, destination.replace('.mp4', '.0000000.jpg')));
      if (successCallback) {
        successCallback(climbId, destination);
      }
    }
  } catch (err) {
    dispatch(errorVideo(climbId, err));
  }
}
